import React, { Component } from 'react';
import { Loader } from 'rsuite';
import PropTypes from 'prop-types';
import PageWrapper from './Wrapper';

export default class MainLayout extends Component {
  componentDidMount() {
    const { onInit, hasInit } = this.props;
    if (!hasInit) onInit();
  }

  render() {
    const { hasInit, children } = this.props;

    return (
      <PageWrapper>
        {hasInit ? children : <Loader backdrop vertical />}
      </PageWrapper>
    );
  }
}

MainLayout.propTypes = {
  hasInit: PropTypes.bool.isRequired,
  onInit: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired
};
